export function formatEtaSeconds(totalSeconds) {
  const sec = Math.max(0, Number(totalSeconds) || 0);
  if (sec < 60) return `${sec}s`;
  const min = Math.floor(sec / 60);
  const rem = sec % 60;
  if (min < 60) return rem > 0 ? `${min}min ${rem}s` : `${min}min`;
  const h = Math.floor(min / 60);
  const m = min % 60;
  return m > 0 ? `${h}h ${m}min` : `${h}h`;
}

export function estimateJobEtaSeconds(job, fallbackStartedAt) {
  const processed = Number(job?.processed ?? job?.scanned ?? 0);
  const total = Number(job?.total);
  if (!Number.isFinite(total) || total <= 0 || processed <= 0 || processed >= total) return null;

  const startedAt = job?.startedAt || fallbackStartedAt;
  if (!startedAt) return null;

  const elapsedMs = Date.now() - new Date(startedAt).getTime();
  if (elapsedMs <= 0) return null;

  const rate = processed / elapsedMs;
  const remaining = total - processed;
  return Math.max(1, Math.round(remaining / rate / 1000));
}

export function scanTokenExpiresAt(finishedAt) {
  if (!finishedAt) return null;
  const t = new Date(finishedAt).getTime();
  if (!Number.isFinite(t)) return null;
  return new Date(t + 60 * 60 * 1000);
}

export function formatExpiresIn(expiresAt) {
  if (!expiresAt) return null;
  const ms = expiresAt.getTime() - Date.now();
  if (ms <= 0) return null;
  return formatEtaSeconds(Math.round(ms / 1000));
}
